// extracted by mini-css-extract-plugin
export default {"root":"PlaceholderPicture_root__YIxEa"};